import { withInstall, withNoopInstall } from '@zoryn/utils'
import Container from './src/container.vue'
import Aside from './src/aside.vue'
import Footer from './src/footer.vue'
import Header from './src/header.vue'
import Main from './src/main.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZContainer: SFCWithInstall<typeof Container> & {
  Aside: typeof Aside
  Footer: typeof Footer
  Header: typeof Header
  Main: typeof Main
} = withInstall(Container, {
  Aside,
  Footer,
  Header,
  Main,
})

export default ZContainer
export const ZAside: SFCWithInstall<typeof Aside> = withNoopInstall(Aside)
export const ZFooter: SFCWithInstall<typeof Footer> = withNoopInstall(Footer)
export const ZHeader: SFCWithInstall<typeof Header> = withNoopInstall(Header)
export const ZMain: SFCWithInstall<typeof Main> = withNoopInstall(Main)

export type ContainerInstance = InstanceType<typeof Container> & unknown
export type AsideInstance = InstanceType<typeof Aside> & unknown
export type FooterInstance = InstanceType<typeof Footer> & unknown
export type HeaderInstance = InstanceType<typeof Header> & unknown
export type MainInstance = InstanceType<typeof Main> & unknown
